<template>
  <q-dialog v-model="isOpen" persistent class="bg-red-5">
    <q-card>
      <q-bar class="bg-red text-white">
        <q-icon name="warning" size="sm" color="orange"></q-icon>
        <div class="text-h6">Alert !</div>
        <q-space />
        <q-btn
          class="q-pl-xs q-ml-md"
          flat
          v-close-popup
          @click="isOpen = false"
          dense
          icon="close"
        />
      </q-bar>
      <DeleteMessageTitle
        :deleteTitle="deleteTitle"
        :deleteMessage="deleteMessage"
      />
      <q-card-actions align="right">
        <q-btn flat label="No" color="negative" @click="handleNo" />
        <q-btn flat label="Yes" color="positive" @click="handleYes" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref } from "vue";
import DeleteMessageTitle from "./../DeleteMessageTitle/DeleteMessageTitle.vue";

const isOpen = ref(false);
let resolvePromise;

const props = defineProps({
  deleteTitle: {
    type: String,
  },
  deleteMessage: {
    type: String,
  },
});

function open() {
  isOpen.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function handleYes() {
  resolvePromise(true);
  isOpen.value = false;
}

function handleNo() {
  resolvePromise(false);
  isOpen.value = false;
}

// Use defineExpose to expose the open method to the parent component
defineExpose({ open });
</script>
